import { render, staticRenderFns } from "./TextResultsLooseWeight.vue?vue&type=template&id=1081aa3f&scoped=true&"
import script from "./TextResultsLooseWeight.vue?vue&type=script&lang=js&"
export * from "./TextResultsLooseWeight.vue?vue&type=script&lang=js&"
import style0 from "./TextResultsLooseWeight.vue?vue&type=style&index=0&id=1081aa3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1081aa3f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Applications/MAMP/htdocs/nc21docker/apps/health/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1081aa3f')) {
      api.createRecord('1081aa3f', component.options)
    } else {
      api.reload('1081aa3f', component.options)
    }
    module.hot.accept("./TextResultsLooseWeight.vue?vue&type=template&id=1081aa3f&scoped=true&", function () {
      api.rerender('1081aa3f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/weight/contentParts/TextResultsLooseWeight.vue"
export default component.exports